import { LoggerStrategies } from 'src/app/constants/logger';

const loggerStrategy = LoggerStrategies.GOOGLE;

const sse = {
  url: 'https://bitcar.mx/v1/service/sse',
  retryInterval: 5000,
  maxRetries: 10,
};

const gtm = {
  googleTagManagerId: 'GTM-K6RK79Z',
};

const incode = {
  host: 'https://saas-onboarding.incodesmile.com/',
  account: 'engencapital666',
  flowDigital: '670d585f2381fa85b80da226',
  flowCredit: '670d5817ad20a466ce66a0e5',
  region: 'region=ALL',
  production: true
}

const bitly = {
  accesToken: '4a134b516d46d4e73dd33d656b10c74a5f254975',
  url: 'https://api-ssl.bitly.com/v4'
}

const keycloak = {
  url: 'https://bitcar.mx/auth',
  realm: 'master',
  clientId: 'client_tip',
  redirectUri: 'https://bitcar.mx/v1',
  bearerExcludedUrls: ['https://cms.bitcar.mx', "https://api-ssl.bitly.com/v4/shorten"],
  registerUrl: 'https://bitcar.mx/auth/realms/master/protocol/openid-connect/registrations?client_id=client_tip&response_type=code&scope=openid email&redirect_uri=https://bitcar.mx/home&kc_locale=es'
};

const miFiel = {
  base: `https://app.mifiel.com/sign-widget-v1.0.0.js`
}

const cookies = {
  domain: 'bitcar.mx'
}

const dataDog = {
  applicationId: '3c084f55-2bab-4000-822a-cf5c5db063c4',
  clientToken: 'pub5ddf9bacf8d409b876fb95373c51f5d3',
  site: 'us5.datadoghq.com',
  service: 'tip-bitcar',
  env: 'prod',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
}

export const environment = {
  production: true,
  templateSuffix: '',
  theme: 'default-theme',
  baseUrl: 'https://bitcar.mx',
  strappiUrl: 'https://cms.bitcar.mx',
  catalog: 'https://api.bitcar.mx/v1/service/catalogs',
  catalogsUrl: 'https://api.bitcar.mx/v1/service/public',
  catalogsUrlV2: 'https://api.bitcar.mx/v2/service/public',
  catalogsUrlV3: 'https://api.bitcar.mx/v3/service/public',
  cotizadorUrl: 'https://api.bitcar.mx/v2/service/public/cotizador',
  cotizadorUrlV2: 'https://api.bitcar.mx/v2/service/public/cotizador',
  cotizadorUrlV3: 'https://api.bitcar.mx/v3/service/public/cotizador',
  configurationUrl: 'https://api.bitcar.mx/v1/service/tipadapter/public',
  keycloak,
  passEncode: 'RAZVCXDIwMjI$',
  tipAdapter: 'https://api.bitcar.mx/v1/service/tipadapter',
  buroUrl: 'https://api.bitcar.mx/v1/service/buro',
  riskUrl: `https://api.bitcar.mx/v1/service/riesgo`,
  sse,
  documentManagmentUrl: 'https://api.bitcar.mx/v2/service/documentmanagment',
  documentManagmentUrlPublic: 'https://api.bitcar.mx/v2/service/public/documentmanagment',
  documentManagmentUrlPublicv3: 'https://bitcar.mx/v1/service/public/documentmanagment',
  otp: 'https://api.bitcar.mx/v2/service/otp/otp',
  solicitudUrl: `https://api.bitcar.mx/v2/service/solicitud`,
  solicitudValidityUrl:
    'https://api.bitcar.mx/v2/service/clientes/expiration-step',
  creditUrl: 'https://api.bitcar.mx/v1/service/credit',
  creditUrlV2: 'https://api.bitcar.mx/v2/service/credit',
  creditUrlV3: 'https://api.bitcar.mx/v3/service/credit',
  clientesUrl: 'https://api.bitcar.mx/v2/service/clientes',
  clientesUrlV3: 'https://api.bitcar.mx/v3/service/clientes',
  clientesPublicUrl: 'https://api.bitcar.mx/v1/service/public/clientes',
  clientesPublicUrlV3: 'https://bitcar.mx/v1/service/public/clientes',
  carManagerUrl: 'https://api.bitcar.mx/v1/service/management/car',
  carManagerUrlV2: 'https://api.bitcar.mx/v2/service/management/car',
  paymentUrl: 'https://api.bitcar.mx/v3/service/payment',
  loggerStrategy,
  gtm,
  miFiel,
  bitly,
  cookies,
  dataDog,
  incode
};
